module.exports = __webpack_public_path__ + "img/20190702161354523.1e72c230.png";